
export default {
  name: 'AssociatedProductLinks',
  props: {
    title: { type: String, required: true },
    products: { type: Array, default: () => [] },
    minHeight: { type: String, default: null },
    limit: { type: Number, default: 12 },
  },
  computed: {
    visibleProducts() {
      return this.products.slice(0, this.limit)
    },
  },
  methods: {
    productLink(product) {
      return this.localePath({
        name: 'produit-slug',
        params: { slug: product.slug },
      })
    },
  },
}
